import {
  IFeatureProductPrices,
  IFeatureProductsData,
  IFeatureProductWithImage,
} from '../models/featured-products.models';
import { ImageUtils } from './image.utils';
import { IProductImage, IProductLabel } from '../models/abstract-product.models';
import { ImagePreset, ImageUrlType } from '../models/image.models';

export class FeaturedProductsUtils {
  static getDisplayableProduct(
    featuredProduct: IFeatureProductsData,
    featuredProductInclude: Array<IProductImage | IFeatureProductPrices | IProductLabel>): IFeatureProductWithImage {
    {
      const imageSetComplete: IProductImage | IFeatureProductPrices | IProductLabel | undefined = featuredProductInclude.find(includeData => includeData.id === featuredProduct.id && includeData.type === 'abstract-product-image-sets');
      const priceSetComplete: IProductImage | IFeatureProductPrices | IProductLabel | undefined = featuredProductInclude.find(includeData => includeData.id === featuredProduct.id && includeData.type === 'abstract-product-prices');
      let priceProduct: number = 0;
      let pricesProduct: IFeatureProductPrices['attributes']['prices'] = [];
      if (priceSetComplete) {
        const priceToAssign: IFeatureProductPrices = (priceSetComplete as IFeatureProductPrices);
        priceProduct = priceToAssign.attributes.price;
        pricesProduct = priceToAssign.attributes.prices;
      }
      return {
        type: featuredProduct.type,
        id: featuredProduct.id,
        attributes: {
          sku: featuredProduct.attributes.sku,
          concreteSku: featuredProduct.attributes?.attributeMap?.product_concrete_ids,
          externalUrlLarge: imageSetComplete
            ? ImageUtils.getProductImageUrl(imageSetComplete, ImagePreset.Preview, ImageUrlType.Large)
            : '',
          externalUrlSmall: imageSetComplete
            ? ImageUtils.getProductImageUrl(imageSetComplete, ImagePreset.Preview)
            : '',
          name: featuredProduct.attributes.name,
          price: priceProduct,
          prices: pricesProduct,
          keywords: featuredProduct.attributes?.attributes?.mcm_keywords as string,
          pricingGroup: featuredProduct?.attributes?.attributes?.sap_p40_material_pricing_group_3 ?? '',
          webshopProductCategory: featuredProduct?.attributes?.attributes?.mcm_webshop_product_category ?? '',
          sap_product_sparepart: featuredProduct?.attributes?.attributes?.sap_product_sparepart as string,
        },
        relationships: featuredProduct.relationships,
      };
    }
  }
}
